var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M473.885,88.279H38.115C17.045,88.402,0,105.517,0,126.617v258.759 c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345V126.617 C512,105.517,494.955,88.402,473.885,88.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M8.828,256.003h238.345c4.875,0,8.828-3.953,8.828-8.828V97.106c0-4.875-3.953-8.828-8.828-8.828 H38.115C17.045,88.402,0,105.517,0,126.617v120.557C0,252.05,3.953,256.003,8.828,256.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M8.828,256.003h15.334l81.77-53.574v53.574h44.138v-53.574l81.77,53.574h15.334 c4.875,0,8.828-3.953,8.828-8.828v-7.002l-70.155-45.963H256v-44.138h-70.155L256,104.108v-7.002c0-4.875-3.953-8.828-8.828-8.828 h-15.334l-81.77,53.574V88.279H105.93v53.574l-79.093-51.82c-9.231,2.9-16.951,9.204-21.707,17.436l65.025,42.603H0v44.138h70.155 L0,240.173v7.002C0,252.05,3.953,256.003,8.828,256.003z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,158.899 141.241,158.899 141.241,88.279 114.759,88.279 114.759,158.899 0,158.899  0,185.382 114.759,185.382 114.759,256.003 141.241,256.003 141.241,185.382 256,185.382  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M8.226,102.904l72.664,47.168h16.213L14.606,96.52C12.237,98.391,10.095,100.535,8.226,102.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M166.283,150.072l88.374-57.366c-1.536-2.599-4.246-4.427-7.485-4.427h-1.909l-95.194,61.793 H166.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M89.474,194.21L1.269,251.464c1.519,2.663,4.273,4.537,7.559,4.537h1.665l95.196-61.793H89.474 V194.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M255.86,247.868l-82.666-53.658H156.98l93.874,60.935 C253.666,253.839,255.595,251.105,255.86,247.868z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M218.666,353.365l-4.726,14.169l-14.936,0.116c-1.432,0.011-2.026,1.839-0.874,2.69l12.015,8.873 l-4.505,14.241c-0.433,1.366,1.123,2.495,2.289,1.663l12.152-8.685l12.152,8.685c1.165,0.833,2.72-0.297,2.289-1.663l-4.505-14.241 l12.015-8.873c1.152-0.851,0.558-2.679-0.874-2.69l-14.936-0.116l-4.726-14.169C221.042,352.006,219.119,352.006,218.666,353.365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M448.735,243.02l-4.726,14.169l-14.936,0.116c-1.432,0.011-2.026,1.839-0.874,2.69l12.015,8.873 l-4.505,14.241c-0.433,1.366,1.123,2.495,2.289,1.663l12.152-8.685l12.152,8.685c1.165,0.833,2.72-0.297,2.289-1.663l-4.505-14.241 l12.015-8.873c1.152-0.851,0.558-2.679-0.874-2.69l-14.936-0.116l-4.726-14.169C451.111,241.661,449.188,241.661,448.735,243.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M448.735,123.847l-4.726,14.169l-14.936,0.116c-1.432,0.011-2.026,1.839-0.874,2.69l12.015,8.873 l-4.505,14.241c-0.433,1.366,1.123,2.495,2.289,1.663l12.152-8.685l12.152,8.685c1.165,0.833,2.72-0.297,2.289-1.663l-4.505-14.241 l12.015-8.873c1.152-0.851,0.558-2.679-0.874-2.69l-14.936-0.116l-4.726-14.169C451.111,122.489,449.188,122.489,448.735,123.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M277.812,278.818l4.665,14.189l-11.915,9.007c-1.142,0.864-0.529,2.685,0.904,2.68l14.936-0.052 l4.885,14.115c0.469,1.354,2.39,1.332,2.828-0.032l4.566-14.222l14.934-0.284c1.432-0.028,2.005-1.862,0.844-2.699l-12.115-8.737 l4.345-14.291c0.417-1.37-1.151-2.483-2.306-1.636l-12.053,8.822l-12.248-8.548C278.906,276.311,277.364,277.457,277.812,278.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M276.708,340.059l4.665,14.189l-11.915,9.007c-1.142,0.864-0.529,2.685,0.904,2.68l14.936-0.052 l4.885,14.115c0.469,1.354,2.39,1.332,2.828-0.032l4.566-14.222l14.934-0.284c1.432-0.028,2.005-1.862,0.844-2.699l-12.115-8.737 l4.345-14.291c0.417-1.37-1.151-2.483-2.306-1.636l-12.053,8.822l-12.248-8.548C277.803,337.552,276.26,338.699,276.708,340.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M341.26,324.611l4.665,14.189l-11.915,9.007c-1.142,0.864-0.529,2.685,0.904,2.68l14.936-0.052 l4.885,14.115c0.469,1.354,2.39,1.332,2.828-0.032l4.566-14.222l14.934-0.284c1.432-0.028,2.005-1.862,0.844-2.699l-12.115-8.737 l4.345-14.291c0.417-1.37-1.151-2.483-2.306-1.636l-12.053,8.822l-12.248-8.548C342.355,322.104,340.812,323.25,341.26,324.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M340.157,191.094l4.665,14.189l-11.915,9.007c-1.142,0.864-0.529,2.685,0.904,2.68l14.936-0.052 l4.885,14.115c0.469,1.354,2.39,1.332,2.828-0.032l4.566-14.222l14.934-0.284c1.432-0.028,2.005-1.862,0.844-2.699l-12.115-8.737 l4.345-14.291c0.417-1.37-1.151-2.483-2.306-1.636l-12.053,8.822l-12.248-8.548C341.251,188.587,339.709,189.733,340.157,191.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M394.777,172.887l4.665,14.189l-11.915,9.007c-1.142,0.864-0.529,2.685,0.904,2.68l14.936-0.052 l4.885,14.115c0.469,1.354,2.39,1.332,2.828-0.032l4.566-14.222l14.934-0.284c1.432-0.028,2.005-1.862,0.844-2.699l-12.115-8.737 l4.345-14.291c0.417-1.37-1.151-2.483-2.306-1.636l-12.053,8.822l-12.248-8.548C395.872,170.38,394.329,171.526,394.777,172.887z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.0adc633f4ec96dc06da3aaf1c623c951.svg";
export { ForwardRef as ReactComponent };